


























































































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'
import * as routerNames from '@/services/router/router.names'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import { IMailboxesInputGeneralSettings } from '@/api/types/request.types'

export default Vue.extend({
  name: 'MailboxSettingsGeneralSettings',

  metaInfo(): any {
    return {
      title: `General Settings - ${this.savedName}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      isLoading: true,
      isUpdating: false,
      isArchiving: false,
      isDeleting: false,

      tagIDsToDelete: [] as number[],

      savedName: '',
      name: '',
      tags: [] as IItemForSelection[],
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    isSubmitting(): boolean {
      return this.isUpdating || this.isArchiving || this.isDeleting
    },
  },

  async created() {
    this.isLoading = true
    await this.getGeneralSettingsInfo()
    this.isLoading = false
  },

  methods: {
    addToTagIDsToDelete(id: number) {
      this.tags = this.tags.filter(t => t.id !== id)
      if (!this.tagIDsToDelete.includes(id)) {
        this.tagIDsToDelete.push(id)
      }
    },
    async getGeneralSettingsInfo() {
      try {
        const response = await MailboxesAPI.get_GeneralSettings(this.id)
        this.name = response.name
        this.savedName = this.name
        this.tags = response.listTags
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async updateMailbox() {
      try {
        this.isUpdating = true
        const data = {
          name: this.name,
          listTagIDsToDelete: this.tagIDsToDelete,
        } as IMailboxesInputGeneralSettings
        const response = await MailboxesAPI.post_GeneralSettings(this.id, data)
        this.savedName = this.name
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error)
        this.name = this.savedName
      } finally {
        this.isUpdating = false
      }
    },
    async handleArchive(): Promise<void> {
      try {
        await this.$confirm(
          `<strong>Forwarded emails to this mailbox will no longer be processed while this is archived.</strong>
          <br>Are you sure you want to archive this mailbox?`,
          {
            dangerouslyUseHTMLString: true,
            center: true,
            confirmButtonText: 'Yes, Archive',
            confirmButtonClass: 'el-button--primary',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'el-button--text',
            type: 'warning',
            title: `Archive this Mailbox`,
          },
        )
        this.isArchiving = true
        await MailboxesAPI.post_Archive(this.id)
        this.$router.push({ name: routerNames.DASHBOARD })
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isArchiving = false
      }
    },
    async handleDelete(): Promise<void> {
      try {
        await this.$confirm(
          `<strong>Forwarded emails to this mailbox will no longer be processed. This action is permanent.</strong>
          <br>Are you sure you want to delete this mailbox?`,
          {
            dangerouslyUseHTMLString: true,
            center: true,
            confirmButtonText: 'Yes, Delete',
            confirmButtonClass: 'el-button--strawberry',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'el-button--text',
            type: 'warning',
            title: `Delete this Mailbox`,
          },
        )
        this.isDeleting = true
        await MailboxesAPI.post_Delete(this.id)
        this.$router.push({ name: routerNames.DASHBOARD })
        this.isDeleting = false
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isDeleting = false
      }
    },
  },
})
